<template>
	<div class="base-table detail-dialog-atble" id="mcq_base-table">
		<el-table ref="multipleTable" :data="tableData" border style="width: 100%" class="tableHeight" @selection-change="handleSelectionChange" @cell-click="handleShowInput">
			<el-table-column type="index" width="50"></el-table-column>
			<el-table-column v-for="(val , index) in table_init" :key="val.prop" :label="val.label" :class-name="val.prop+'_alias'">
				<!-- :fixed="val.prop =='itemname'"  -->
				<template scope="scope">
					<!-- 下拉框 -->
					<template v-if="val.prop === 'progress'">
						<template v-if="isEdit">
							<select style="display:none;width: 100%;" @blur="handleHideSelect($event , scope.$index)" :name="val.prop">
								<option value=""></option>
								<option v-for="select in progressList" :key="select.prop" :value="select.prop">{{select.name}}</option>
							</select>
							<span :name="val.prop" class="showSelectName" :title="scope.row[val.prop]">{{switchProgress(scope.row[val.prop])}}</span>
						</template>
						<span v-else :name="val.prop+'_'+scope.$index">{{switchProgress(scope.row[val.prop])}}</span>
					</template>
					<!-- 普通 -->
					<template v-else>
						<input  v-if="scope.$index < tableDataLen-2" style="display:none;width: 100%;" @blur="handleHideText($event , scope.$index)" :name="val.prop">
						<textarea  v-else style="display:none;width: 100%;height:100%" :name="val.prop" @blur="handleHideText($event , scope.$index)"></textarea>
						<span :name="val.prop+'_'+scope.$index">{{scope.row[val.prop]}}</span>
					</template>
				</template>
			</el-table-column>
			<el-table-column label="附件查看" v-if="!isEdit" width="120" :class-name="'attachView_alias'">
				<template scope="scope">
					<button class="btn btn-default" @click="attachOperate('attachDetail', scope.row)">附件查看</button>
				</template>
			</el-table-column>
			<el-table-column prop="" label="附件上传" v-if="isEdit" width="120" :class-name="'attachUpload_alias'">
				<template scope="scope">
					<button class="btn btn-default" @click="attachOperate('attachUpload', scope.row)">附件上传</button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>

export default {
	props: ["tableData", "isEdit"],
	updated() {
		this.$nextTick(function() {
			console.log("updated")
			this.tableDataLen = this.tableData.length;
			// length==1是表头渲染完成
			let len = $(".itemname_alias").length;
			if (len > 2 && 	this.tableData[this.tableDataLen -1 ].id == null) {
				let removeTd = [
					"structType_alias",
					"archArea_alias",
					"hzgaint_alias",
					"progress_alias",
					"progressmx_alias",
					"attachView_alias",
					"attachUpload_alias"
				]
				removeTd.forEach(td => {
					$($("." + td)[len - 1]).remove();
					$($("." + td)[len - 2]).remove();
				})
				$($(".itemname_alias")[len - 1]).attr("colspan", "6");
				$($(".itemname_alias")[len - 2]).attr("colspan", "6");
				$($(".itemname_alias")[len - 1]).html("整改情况");
				$($(".itemname_alias")[len - 2]).html("存在问题");
				$($(".itemname_alias")[len - 1]).css("text-align", "center");
				$($(".itemname_alias")[len - 2]).css("text-align", "center");
			}
            let h = $("#mcq_base-table").parents(".el-dialog__body")[0].offsetHeight;
            $(".tableHeight .el-table__body-wrapper")[0].style.height = "auto";
            if(h<$("#mcq_base-table")[0].offsetHeight){
                $(".tableHeight .el-table__body-wrapper")[0].style.height = (h-90) + "px";
            }
		})
	},
	data() {
		return {
			tableDataLen:-1,
			multipleSelection: "",
			table_init: obj,
			editableCol: ["progress_alias", "progressmx_alias", "xmgaint1_alias", "xmgaint2_alias", "xmgaint3_alias", "xmgaint4_alias", "xmgaint5_alias", "xmgaint6_alias", "xmgaint7_alias", "xmgaint8_alias", "xmgaint9_alias", "xmgaint10_alias"],
			progressList: [{ name: "未开工", prop: "6" }, { name: "桩基", prop: "1" }, { name: "基础", prop: "2" }, { name: "主体结构", prop: "3" }, { name: "装饰装修", prop: "4" }, { name: "完工", prop: "5" }]
		}
	},
	methods: {
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		//只有编辑界面会用到这个函数
		handleShowInput(row, column, cell, event) {
			let include = false;
			for (let i in this.editableCol) {
				if (this.editableCol[i] == column.className) {
					include = true;
					break;
				}
			}
			if (this.isEdit && include) {//this.editableCol.includes(column.className)
				if (column.className === "progress_alias") {
					if ($(cell).find("select")[0].style.display === "block") {

					} else {
						$(cell).find("select")[0].value = $(cell).find("span")[0].title;
						$(cell).find("select")[0].style.display = "block";
					}
				} else {
					if ($(cell).find("input").length > 0) {
						$(cell).find("input")[0].value = $(cell).find("span")[0].innerHTML;
						$(cell).find("input")[0].style.display = "block";
						$(cell).find("input")[0].focus();
					} else if ($(cell).find("textarea").length > 0) {
						$(cell).find("textarea")[0].value = $(cell).find("span")[0].innerHTML;
						$(cell).find("textarea")[0].style.display = "block";
						$(cell).find("textarea")[0].focus();
					}
				}
				$(cell).find("span")[0].style.display = "none";
			}
		},
		//只有编辑界面会用到这个函数
		handleHideText(evt, index) {
			if (evt) {
				evt.target.style.display = "none";
				$(evt.target).next("span").css("display", "block")
			}
			this.tableData[index][evt.target.getAttribute('name')] = evt.target.value;
		},
		handleHideSelect(evt, index) {//select的隐藏
			evt.target.style.display = "none";
			$(evt.target).next("span").css("display", "block")
			this.tableData[index]['progress'] = evt.target.value;

		},
		attachOperate(name, row) {
			this.$emit("attachOperate", { name: name, row: row })
		},
		queryDetail() {

		},
		doSave() {
		},
		switchProgress(val) {
			// progress过滤器
			let name = "";
			for (let i in this.progressList) {
				if (this.progressList[i].prop === val) {
					name = this.progressList[i].name;
					break;
				}
			}
			return name;
		},
	},
}
let obj = [
	{ label: "单位工程名称", prop: "itemname", showInput: false },
	{ label: "建筑面积", prop: "archArea", showInput: false },
	{ label: "结构类型", prop: "structType", showInput: false },
	{ label: "总体评价分", prop: "hzgaint", showInput: false },
	{ label: "形象进度", prop: "progress", showInput: false },
	{ label: "详细进度", prop: "progressmx", showInput: false },
	{ label: "安全管理(满分10分)", prop: "xmgaint1", showInput: false },
	{ label: "文明施工(满分15分)", prop: "xmgaint2", showInput: false },
	{ label: "脚手架(满分10分)", prop: "xmgaint3", showInput: false },
	{ label: "基坑工程(满分10分)", prop: "xmgaint4", showInput: false },
	{ label: "模板支架(满分10分)", prop: "xmgaint5", showInput: false },
	{ label: "高处作业(满分10分)", prop: "xmgaint6", showInput: false },
	{ label: "施工用电(满分10分)", prop: "xmgaint7", showInput: false },
	{ label: "物料提升机与施工升降机(满分10分)", prop: "xmgaint8", showInput: false },
	{ label: "塔式起重机与起重吊装(满分10分)", prop: "xmgaint9", showInput: false },
	{ label: "施工机具(满分5分)", prop: "xmgaint10", showInput: false },
]
</script>
<style>
.monthCheckQuery .detail-dialog-atble .el-table__body-wrapper {
	overflow: auto;
}
.tableHeight .el-table__body-wrapper{
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// detail_dialog_table.vue?ea53275a